import PropTypes from 'prop-types';
import Field from '@base/Form/Field';
import {
  FormContainer,
  FormSectionHeading,
  FieldWrapper,
  StyledDropdown,
  Error,
  FieldWrapperFlex,
  StyledNumberFieldFlex,
  FieldWrapperSmall,
  FormSectionSubHeading
} from './styles';
import { classes } from '../constants';
import { isImageSizeValid, isImageTypeValid, isRequired } from './utils';
import FileUploader from './FileUploader';

const renderErrorMessage = ({ message }) => {
  return <Error>{message}</Error>;
};

const LastClassDetails = ({ registrar, updateStoreData }) => {
  return (
    <FormContainer>
      <FormSectionHeading>Last class details</FormSectionHeading>

      <FieldWrapperFlex>
        <FieldWrapper>
          <Field
            registrar={registrar}
            name="class"
            rules={[isRequired('Last class is required')]}
            render={({ onChange, value }) => (
              <StyledDropdown
                options={classes}
                placeholder="Last class attended"
                selectedOption={value}
                onOptionClick={(data) => {
                  onChange(data);
                  updateStoreData('class', data);
                }}
                buttonWidth="204px"
              />
            )}
            renderError={renderErrorMessage}
          />
        </FieldWrapper>
        <FieldWrapper>
          <Field
            registrar={registrar}
            name="examCgpa"
            rules={[isRequired('Last class CGPA / %  is required')]}
            render={({ onChange, value, hasError }) => (
              <StyledNumberFieldFlex
                placeholder="Last class CGPA / %"
                value={value}
                onChange={(_, d) => {
                  onChange(d);
                  updateStoreData('examCgpa', d);
                }}
                error={hasError}
                type="number"
                allowFloat
                uppperLimit={100}
                lowerLimit={0}
              />
            )}
            renderError={renderErrorMessage}
          />
        </FieldWrapper>
      </FieldWrapperFlex>
      <FormSectionSubHeading>
        Upload mark sheet / certificate
      </FormSectionSubHeading>
      <FieldWrapperSmall>
        <Field
          registrar={registrar}
          name="candidateMarksheet"
          rules={[
            isRequired('Upload the image'),
            isImageTypeValid('Upload an image in .png or .jpg format'),
            isImageSizeValid('Image size should not exceed 10 MB')
          ]}
          render={({ onChange, value, hasError }) => (
            <FileUploader
              value={value}
              error={hasError}
              onOptionClick={(data) => {
                onChange(data);
                updateStoreData('candidateMarksheet', data);
              }}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapperSmall>
    </FormContainer>
  );
};

LastClassDetails.propTypes = {
  registrar: PropTypes.objectOf(PropTypes.any).isRequired
};

export default LastClassDetails;
